module.exports = __webpack_public_path__ + "static/media/edit-cartIcon.248b2642.svg";